module.exports = __webpack_public_path__ + "img/reserved_selected.10927dae.svg";